import React from 'react';
import { SupportedLanguage } from '../../types/language';
import { useTranslation } from 'react-i18next';
import { Modal } from '../common/Modal';

interface HelpModalProps {
  isOpen: boolean;
  onClose: () => void;
  language?: SupportedLanguage;
  translations?: any; // unused, kept for compatibility
}

export const HelpModal: React.FC<HelpModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
        <h2 className="text-2xl font-bold mb-6">{t('public.help.title')}</h2>
        
        <div className="space-y-6">
          <div>
            <h3 className="font-semibold text-lg mb-2">{t('public.help.whatWeDo')}</h3>
            <p className="text-gray-600">{t('public.help.whatWeDoText')}</p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">{t('public.help.understandingScore')}</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-12 h-8 bg-green-500 rounded flex-shrink-0"></div>
                <div>
                  <p className="font-medium">{t('public.help.green')}</p>
                  <p className="text-sm text-gray-600">{t('public.help.greenText')}</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-12 h-8 bg-yellow-500 rounded flex-shrink-0"></div>
                <div>
                  <p className="font-medium">{t('public.help.yellow')}</p>
                  <p className="text-sm text-gray-600">{t('public.help.yellowText')}</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-12 h-8 bg-red-500 rounded flex-shrink-0"></div>
                <div>
                  <p className="font-medium">{t('public.help.red')}</p>
                  <p className="text-sm text-gray-600">{t('public.help.redText')}</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">{t('public.help.usingTimeline')}</h3>
            <p className="text-gray-600">{t('public.help.usingTimelineText')}</p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-2">{t('public.help.languageSupport')}</h3>
            <p className="text-gray-600">{t('public.help.languageSupportText')}</p>
          </div>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
            <h3 className="font-semibold text-amber-900 mb-1">{t('public.help.disclaimer')}</h3>
            <p className="text-sm text-amber-800">{t('public.help.disclaimerText')}</p>
          </div>
        </div>

        <button
          onClick={onClose}
          className="mt-6 w-full bg-blue-600 text-white rounded-lg px-4 py-3 hover:bg-blue-700 font-medium"
        >
          {t('public.help.gotIt')}
        </button>
    </Modal>
  );
};
